// @flow
// Ensure any changes here are also made to the localeDetection file
module.exports = {
  USER_LANGUAGE_STORAGE_KEY: 'ts-website-language',
  GEO_LOCATION_STORAGE_KEY: 'ts-website-geoip',
  ROOT_LOCALE: 'ja'
};
